import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Dashboard from './views/Operations/Dashboard'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Dashboard,
      beforeEnter: checkAuth,
      meta: {
        title: '운행 현황'
      }
    },
    {
      path: '/operation/map',
      name: 'operation-map',
      component: () => import('./views/Operations/Map'),
      beforeEnter: checkAuth,
      meta: {
        title: '차량 위치'
      }
    },
    {
      path: '/history/days',
      name: 'history-days',
      component: () => import('./views/History/Days'),
      beforeEnter: checkAuth,
      meta: {
        title: '차량별 운행 이력'
      }
    },
    {
      path: '/history/etas',
      name: 'history-etas',
      component: () => import('./views/History/Etas'),
      beforeEnter: checkAuth,
      meta: {
        title: 'ETAS 파일 요청'
      }
    },
    {
      path: '/history/non-receipt',
      name: 'history-non-receipt',
      component: () => import('./views/History/Non-receipt'),
      beforeEnter: checkAuth,
      meta: {
        title: '미수신 차량 내역'
      }
    },
    {
      path: '/stat/devices/smartscore',
      name: 'stat-devices-smartscore',
      component: () => import('./views/Statistics/Devices-smartscore'),
      beforeEnter: checkAuth,
      meta: {
        title: '차량별 스마트 운전 기록'
      }
    },
    {
      path: '/stat/drivers/smartscore',
      name: 'stat-drivers-smartscore',
      component: () => import('./views/Statistics/Drivers-smartscore'),
      beforeEnter: checkAuth,
      meta: {
        title: '운전자별 스마트 운전 기록'
      }
    },
    {
      path: '/stat/drivers/smartscore-total',
      name: 'stat-drivers-smartscore-total',
      component: () => import('./views/Statistics/Drivers-smartscore-total'),
      beforeEnter: checkAuth,
      meta: {
        title: '운전자별 스마트 운전 통계'
      }
    },
    {
      path: '/settings/areas',
      name: 'settings-areas',
      component: () => import('./views/Settings/Areas/List'),
      beforeEnter: checkAuth,
      meta: {
        title: '공회전 제한 구역 관리'
      }
    },
    {
      path: '/settings/areas/edit/:_id',
      name: 'settings-areas-edit-_id',
      component: () => import('./views/Settings/Areas/Edit'),
      beforeEnter: checkAuth,
      meta: {
        title: '공회전 제한 구역 관리'
      }
    },
    {
      path: '/settings/areas/new',
      name: 'settings-areas-new',
      component: () => import('./views/Settings/Areas/Edit'),
      beforeEnter: checkAuth,
      props: {
        new: true
      },
      meta: {
        title: '새 구역 만들기'
      }
    },
    {
      path: '/settings/set/areas',
      name: 'settings-set-areas',
      component: () => import('./views/Settings/SetAreas/List'),
      beforeEnter: checkAuth,
      meta: {
        title: '공회전 제한 구역 설정'
      }
    },
    {
      path: '/settings/set/params',
      name: 'settings-set-params',
      component: () => import('./views/Settings/SetParams/List'),
      beforeEnter: checkAuth,
      meta: {
        title: '공회전 파라미터 설정'
      }
    },
    {
      path: '/settings/devices',
      name: 'settings-devices',
      component: () => import('./views/Settings/Devices/List'),
      beforeEnter: checkAuth,
      meta: {
        title: '공회전 ON/OFF 관리'
      }
    },
    {
      path: '/settings/vehicles',
      name: 'settings-vehicles',
      component: () => import('./views/Settings/Vehicles/List'),
      beforeEnter: checkAuth,
      meta: {
        title: '차량 관리'
      }
    },
    {
      path: '/settings/vehicles/edit/:_id',
      name: 'settings-vehicles-edit-_id',
      component: () => import('./views/Settings/Vehicles/Edit'),
      beforeEnter: checkAuth,
      meta: {
        title: '차량 관리'
      }
    },
    {
      path: '/settings/groups',
      name: 'settings-groups',
      component: () => import('./views/Settings/Groups/List'),
      beforeEnter: checkAuth,
      meta: {
        title: '노선 관리'
      }
    },
    {
      path: '/settings/groups/new',
      name: 'settings-groups-new',
      component: () => import('./views/Settings/Groups/Edit'),
      beforeEnter: checkAuth,
      props: {
        new: true
      },
      meta: {
        title: '새 노선 만들기'
      }
    },
    {
      path: '/settings/groups/edit/:_id',
      name: 'settings-groups-edit-_id',
      component: () => import('./views/Settings/Groups/Edit'),
      beforeEnter: checkAuth,
      meta: {
        title: '노선 관리'
      }
    },
    {
      path: '/settings/drivers',
      name: 'settings-drivers',
      component: () => import('./views/Settings/Drivers/List'),
      beforeEnter: checkAuth,
      meta: {
        title: '운전자 관리'
      }
    },
    {
      path: '/settings/drivers/new',
      name: 'settings-drivers-new',
      component: () => import('./views/Settings/Drivers/Edit'),
      beforeEnter: checkAuth,
      props: {
        new: true
      },
      meta: {
        title: '새 운전자 만들기'
      }
    },
    {
      path: '/settings/drivers/edit/:_id',
      name: 'settings-drivers-edit-_id',
      component: () => import('./views/Settings/Drivers/Edit'),
      beforeEnter: checkAuth,
      meta: {
        title: '운전자 관리'
      }
    },
    {
      path: '/settings/plans',
      name: 'settings-plans',
      component: () => import('./views/Settings/Plans/List'),
      beforeEnter: checkAuth,
      meta: {
        title: '운전자 배차 관리'
      }
    },
    {
      path: '/settings/plans/new',
      name: 'settings-plans-new',
      component: () => import('./views/Settings/Plans/Edit'),
      beforeEnter: checkAuth,
      props: {
        new: true
      },
      meta: {
        title: '운전자 배차'
      }
    },
    {
      path: '/settings/plans/edit/:_id',
      name: 'settings-plans-edit-_id',
      component: () => import('./views/Settings/Plans/Edit'),
      beforeEnter: checkAuth,
      meta: {
        title: '배차 정보 수정'
      }
    },
    {
      path: '/settings/company',
      name: 'settings-company',
      component: () => import('./views/Settings/Company/Edit'),
      beforeEnter: checkAuth,
      meta: {
        title: '회사 정보'
      }
    },
    {
      path: '/settings/password',
      name: 'settings-password',
      component: () => import('./views/Settings/Password/Edit'),
      beforeEnter: checkAuth,
      meta: {
        title: '비밀번호 변경'
      }
    },
    {
      path: '/signin',
      name: 'signin',
      meta: {
        layout: 'no-app-bar'
      },
      component: () => import('./views/Auth/Signin.vue')
    },
    {
      path: '/policy',
      name: 'policy',
      meta: {
        layout: 'no-app-bar'
      },
      component: () => import('./views/Policy.vue')
    },
    {
      path: '/policy2',
      name: 'policy2',
      meta: {
        layout: 'no-app-bar'
      },
      component: () => import('./views/Policy2.vue')
    },
    {
      path: '/policy/20181101',
      name: 'policy20181101',
      meta: {
        layout: 'no-app-bar'
      },
      component: () => import('./views/Policy20181101.vue')
    },
    {
      path: '/service_location',
      name: 'serviceLocation',
      meta: {
        layout: 'no-app-bar'
      },
      component: () => import('./views/ServiceLocation.vue')
    },
    {
      path: '*',
      name: '404',
      meta: {
        layout: 'no-app-bar'
      },
      component: () => import('./views/404.vue')
    }
  ]
})

function checkAuth (to, from, next) {
  if (!store.state.isLoggedIn) next('/signin')
  else next()
}

function checkAdmin (to, from, next) {
  if (!store.state.isLoggedIn) return next('/signin')

  if (store.state.user.isAdmin) return next()

  if (store.state.user._cps.length > 1) return next()

  return next('/')
}
